// HM-346 cluster 16.1.5: client API per /guests/search (autocomplete walk-in Step 2).

import { api } from './client.js';

export type GuestSearchResult = {
  id: string;
  firstName: string;
  lastName: string;
  email: string | null;
  phone: string | null;
  documentType: string | null;
  documentNumber: string | null;
};

export async function searchGuests(
  q: string,
  limit?: number,
): Promise<{ guests: GuestSearchResult[] }> {
  const params = new URLSearchParams({ q });
  if (limit) params.set('limit', String(limit));
  return api(`/guests/search?${params.toString()}`);
}
